<p-dialog
  [visible]="scanService.dialogVisible()"
  (visibleChange)="onVisibleChange($event)"
  [header]="'Scan ' + (scanService.request()?.filename ?? 'attachment')"
  [modal]="true"
  [closable]="!scanService.starting()"
  appendTo="body"
  [style]="{ width: 'min(900px, 92vw)' }"
>
  @if (scanService.dialogVisible()) {
  <div class="flex flex-col gap-4">
    <p class="text-sm text-muted">
      Choose the keywords to scan this document for, then start the scan. Progress
      appears in the uploads panel.
    </p>

    @if (scanService.suggesting() || scanService.suggestions().length) {
    <div class="flex flex-col gap-2 rounded-md border border-borderColor bg-slate-50 p-3">
      <p class="text-xs font-medium text-content">Suggested from this conversation (not in your library)</p>
      @if (scanService.suggesting()) {
      <div class="flex items-center gap-2 text-sm text-muted">
        <i class="pi pi-spin pi-spinner"></i>
        <span>Looking for new keyword ideas…</span>
      </div>
      } @else {
      <div class="flex flex-wrap gap-2">
        @for (suggestion of scanService.suggestions(); track suggestion.name) {
        <button
          type="button"
          class="flex cursor-pointer items-center gap-2 rounded-full border px-3 py-1 text-sm transition-colors"
          [ngClass]="isSuggestionSelected(suggestion) ? 'border-primary bg-primary-50 text-primary' : 'border-borderColor text-content hover:bg-white'"
          (click)="toggleSuggestion(suggestion)"
        >
          <i class="pi text-xs" [ngClass]="isSuggestionSelected(suggestion) ? 'pi-check-circle' : 'pi-plus-circle text-muted'"></i>
          <span>{{ suggestion.name }}</span>
          <span class="text-xs text-muted">{{ suggestion.riskRating }}</span>
        </button>
        }
      </div>
      <small class="text-xs text-muted">Selected suggestions are added to your keyword library when you start the scan.</small>
      }
    </div>
    }

    @if (scanService.inferring()) {
    <div class="flex items-center justify-center gap-2 py-8 text-sm text-muted">
      <i class="pi pi-spin pi-spinner"></i>
      <span>Finding keywords relevant to this conversation…</span>
    </div>
    } @else {
    @if (scanService.inferenceRan() && !scanService.initialKeywords().length) {
    <p class="text-xs text-muted">
      No keywords matched this conversation automatically — pick the ones to scan for below.
    </p>
    }
    <app-add-keywords-scan
      [initialSelectedKeywords]="scanService.initialKeywords()"
      (selectionChanged)="onSelectionChanged($event)"
    ></app-add-keywords-scan>
    }
  </div>
  }

  <ng-template pTemplate="footer">
    <p-button
      label="Cancel"
      severity="secondary"
      styleClass="cursor-pointer disabled:cursor-default"
      (click)="onVisibleChange(false)"
      [disabled]="scanService.starting()"
    ></p-button>
    <p-button
      label="Start scan"
      icon="pi pi-search"
      styleClass="cursor-pointer disabled:cursor-default"
      (click)="start()"
      [loading]="scanService.starting()"
      [disabled]="!hasSelection || scanService.starting()"
    ></p-button>
  </ng-template>
</p-dialog>
